import styles from 'styles/FillingWrapper.module.css'
const Wrapper = ({ children, ...rest }) =>
    <div className={styles.wrap} {...rest}>
        { children }
    </div>
export default Wrapper